import { Injectable } from '@angular/core';

type AssetFolder = 'logo' | 'sessions';

@Injectable({
	providedIn: 'root'
})
export class AssetsService {
	constructor() {}

	getAssetFileUrl(folder: AssetFolder, filename: string): string {
		return `/assets/${folder}/${filename}`;
	}

	getAppVersionJsonUrl(): string {
		return `/assets/appVersion.json`;
	}
}
